/* ============================================================
   GROOVY COMPUTERS — THEME JS v1.0
   Popup · Drawer · Toast · FAB · Accordion · Finance Tabs
   ============================================================ */
(function () {
  'use strict';

  /* ---- Helpers ---- */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  /* ---- Focus Trap ---- */
  function trapFocus(el) {
    const focusable = el.querySelectorAll(
      'a[href],button:not([disabled]),textarea,input,select,[tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    el._trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    el.addEventListener('keydown', el._trapHandler);
    first.focus();
  }
  function releaseFocus(el) {
    if (el._trapHandler) el.removeEventListener('keydown', el._trapHandler);
  }

  /* ---- Drawer System ---- */
  function openDrawer(drawerId) {
    const drawer = document.getElementById(drawerId);
    const backdrop = document.getElementById(drawerId + '-backdrop');
    if (!drawer) return;
    drawer.setAttribute('data-open', '');
    if (backdrop) backdrop.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    trapFocus(drawer);
    drawer.setAttribute('aria-hidden', 'false');
  }
  function closeDrawer(drawerId) {
    const drawer = document.getElementById(drawerId);
    const backdrop = document.getElementById(drawerId + '-backdrop');
    if (!drawer) return;
    drawer.removeAttribute('data-open');
    if (backdrop) backdrop.removeAttribute('data-open');
    document.body.style.overflow = '';
    releaseFocus(drawer);
    drawer.setAttribute('aria-hidden', 'true');
  }

  /* ---- Popup System ---- */
  function openPopup(popupId) {
    const popup = document.getElementById(popupId);
    const backdrop = document.getElementById(popupId + '-backdrop');
    if (!popup) return;
    popup.setAttribute('data-open', '');
    if (backdrop) backdrop.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    trapFocus(popup);
  }
  function closePopup(popupId) {
    const popup = document.getElementById(popupId);
    const backdrop = document.getElementById(popupId + '-backdrop');
    if (!popup) return;
    popup.removeAttribute('data-open');
    if (backdrop) backdrop.removeAttribute('data-open');
    document.body.style.overflow = '';
    releaseFocus(popup);
  }

  /* ---- Campaign Popup (timed) ---- */
  function initCampaignPopup() {
    const popup = $('#groovy-campaign-popup');
    if (!popup) return;
    const delay = parseInt(popup.dataset.delay || '5', 10) * 1000;
    const onceKey = popup.dataset.onceKey || 'groovy_popup_seen';
    const showOnce = popup.dataset.showOnce === 'true';
    if (showOnce && sessionStorage.getItem(onceKey)) return;

    setTimeout(function () {
      openPopup('groovy-campaign-popup');
      if (showOnce) sessionStorage.setItem(onceKey, '1');
    }, delay);
  }

  /* ---- Exit Intent (desktop) ---- */
  function initExitIntent() {
    const popup = $('#groovy-exit-popup');
    if (!popup) return;
    if (sessionStorage.getItem('groovy_exit_shown')) return;
    if ('ontouchstart' in window) return; // skip mobile

    let triggered = false;
    document.addEventListener('mouseout', function (e) {
      if (triggered) return;
      if (e.clientY > 10) return;
      triggered = true;
      sessionStorage.setItem('groovy_exit_shown', '1');
      openPopup('groovy-exit-popup');
    });
  }

  /* ---- Toast System ---- */
  const toastQueue = [];
  let toastActive = false;

  function showToast(config) {
    toastQueue.push(config);
    if (!toastActive) processToastQueue();
  }

  function processToastQueue() {
    if (!toastQueue.length) { toastActive = false; return; }
    toastActive = true;
    const cfg = toastQueue.shift();
    const el = $('#groovy-toast');
    if (!el) { toastActive = false; return; }

    const iconEl = el.querySelector('.groovy-toast__icon');
    const contentEl = el.querySelector('.groovy-toast__content');
    if (iconEl) iconEl.textContent = cfg.icon || '🔔';
    if (contentEl) contentEl.innerHTML = cfg.html || '';

    el.setAttribute('data-show', '');
    const duration = cfg.duration || 5000;
    setTimeout(function () {
      el.removeAttribute('data-show');
      setTimeout(processToastQueue, 600);
    }, duration);
  }

  function initToastCycle() {
    const el = $('#groovy-toast');
    if (!el) return;
    let messages;
    try {
      messages = JSON.parse(el.dataset.messages || '[]');
    } catch (e) { return; }
    if (!messages.length) return;

    const interval = parseInt(el.dataset.interval || '30', 10) * 1000;
    let idx = 0;
    function cycle() {
      showToast(messages[idx]);
      idx = (idx + 1) % messages.length;
    }
    setTimeout(function () {
      cycle();
      setInterval(cycle, interval);
    }, interval);
  }

  /* ---- FAB (Floating Action Button) ---- */
  function initFab() {
    const fab = $('.groovy-fab');
    if (!fab) return;
    const trigger = fab.querySelector('.groovy-fab__trigger');
    if (!trigger) return;

    trigger.addEventListener('click', function () {
      const expanded = fab.hasAttribute('data-expanded');
      if (expanded) {
        fab.removeAttribute('data-expanded');
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        fab.setAttribute('data-expanded', '');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!fab.contains(e.target)) {
        fab.removeAttribute('data-expanded');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- Accordion ---- */
  function initAccordions() {
    $$('.groovy-accordion__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        if (isOpen) {
          panel.removeAttribute('data-open');
        } else {
          panel.setAttribute('data-open', '');
        }
      });
    });
  }

  /* ---- Finance Tabs ---- */
  function initFinanceTabs() {
    const container = $('.groovy-financing-hub');
    if (!container) return;
    const tabs = $$('.groovy-finance-tab', container);
    const panels = $$('.groovy-finance-panel', container);

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.removeAttribute('data-active'); });
        tab.setAttribute('aria-selected', 'true');
        const target = document.getElementById(tab.dataset.target);
        if (target) target.setAttribute('data-active', '');
      });
    });
  }

  /* ---- Global Delegated Close Handlers ---- */
  document.addEventListener('click', function (e) {
    // Close popup
    const popupClose = e.target.closest('[data-close-popup]');
    if (popupClose) {
      closePopup(popupClose.dataset.closePopup);
      return;
    }
    // Close drawer
    const drawerClose = e.target.closest('[data-close-drawer]');
    if (drawerClose) {
      closeDrawer(drawerClose.dataset.closeDrawer);
      return;
    }
    // Open drawer
    const drawerOpen = e.target.closest('[data-open-drawer]');
    if (drawerOpen) {
      e.preventDefault();
      openDrawer(drawerOpen.dataset.openDrawer);
      return;
    }
    // Backdrop dismiss
    if (e.target.classList.contains('groovy-drawer-backdrop')) {
      const drawerId = e.target.id.replace('-backdrop', '');
      closeDrawer(drawerId);
    }
  });

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.groovy-drawer[data-open]').forEach(function (d) { closeDrawer(d.id); });
    $$('.groovy-popup[data-open]').forEach(function (p) { closePopup(p.id); });
  });

  /* ---- Scroll Reveal (IntersectionObserver) ---- */
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything
      $$('[data-groovy-reveal], [data-groovy-stagger]').forEach(function (el) {
        el.classList.add('groovy-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('groovy-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    });

    $$('[data-groovy-reveal], [data-groovy-stagger]').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---- Marquee Pause on Hover ---- */
  function initMarquee() {
    $$('.groovy-marquee').forEach(function (marquee) {
      var track = marquee.querySelector('.groovy-marquee__track');
      if (!track) return;
      marquee.addEventListener('mouseenter', function () {
        track.style.animationPlayState = 'paused';
      });
      marquee.addEventListener('mouseleave', function () {
        track.style.animationPlayState = 'running';
      });
    });
  }

  /* ---- Init on DOM Ready ---- */
  function init() {
    initCampaignPopup();
    initExitIntent();
    initToastCycle();
    initFab();
    initAccordions();
    initFinanceTabs();
    initScrollReveal();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for external use
  window.GroovyTheme = { openDrawer: openDrawer, closeDrawer: closeDrawer, openPopup: openPopup, closePopup: closePopup, showToast: showToast };
})();
